import { ApiState } from '../utils/requestAction';
import requestReducer from './requestReducer';


export interface NotifySchoolsState extends ApiState {
  success?: boolean
}

export default requestReducer<NotifySchoolsState>('NOTIFY_SCHOOLS')
